import { gql } from "@apollo/client";

export const UserComboboxTeamOptionFragment = gql`
  fragment UserComboboxTeamOption on TeamNode {
    id
    title
  }
`;
export const UserComboboxUserOptionFragment = gql`
  fragment UserComboboxUserOption on UserNode {
    id
    name
    firstName
    email
    avatar
    activeAssessmentNominationCount
      @include(if: $showActiveAssessmentNominationCount)
    membershipStatus(organizationId: $organizationId)
  }
`;

export default gql`
  ${UserComboboxTeamOptionFragment}
  ${UserComboboxUserOptionFragment}
  query getUserComboboxOptionsQuery(
    $userId: Int!
    $hasUserId: Boolean!
    $teamId: Int!
    $hasTeamId: Boolean!
    $search: String
    $limitUser: Int!
    $organizationId: Int
    $excludeUserIds: [Int]
    $excludeTeamIds: [Int]
    $showActiveAssessmentNominationCount: Boolean!
    $includeDeactivated: Boolean
  ) {
    users(
      orderBy: "affinity"
      first: $limitUser
      search: $search
      organizationId: $organizationId
      excludeIds: $excludeUserIds
      includeDeactivated: $includeDeactivated
    ) {
      edges {
        node {
          ...UserComboboxUserOption
        }
      }
    }
    teams(
      organization: $organizationId
      search: $search
      first: 10
      excludeIds: $excludeTeamIds
      orderBy: "title"
    ) {
      edges {
        node {
          ...UserComboboxTeamOption
        }
      }
    }
    team(teamId: $teamId) @include(if: $hasTeamId) {
      ...UserComboboxTeamOption
    }
    user(userId: $userId) @include(if: $hasUserId) {
      ...UserComboboxUserOption
    }
  }
`;
